import React from "react";
import FHAFamily from "../../PicesForPages/FHA_family2.webp";
import FreeConsultation from "../Form/FreeConsultation";

function FHA() {
  return (
    <div className="purchaseParent">
      <div className="purchasetopParent">
        <img
          fetchPriority="high"
          loading="eager"
          src={FHAFamily}
          alt="FHAFamilyImage"
          className="background-video aboutUsImage"
        />
        <div className="purchasetopBox">
          {/* The existing Purchase span */}
          <span>FHA Loans</span>
        </div>
      </div>
      <div className="purchaseBottomParent">
        <div className="purchaseBottomBox">
          <div className="purchaseBottomLeftBox">
            <span className="purchaseBottomLeftContent">
              FHA loans, backed by the Federal Housing Administration, have
              become a popular choice for first-time homebuyers and those with
              less-than-perfect credit. They offer distinct advantages but also
              come with certain considerations. Below we outline the major pros
              and cons to help you make an informed decision.
            </span>
            <span className="purchaseBottomLeftSubHeader">Pros:</span>
            <ul className="purchaseBottomLeftUL paperworkBottomLeftUL">
              <li>
                <b>Low Down Payment:</b> FHA loans require a smaller down
                payment than many conventional loans, making homeownership more
                accessible for buyers who lack a significant upfront payment.
              </li>
              <li>
                <b>Flexible Credit Requirements:</b> These loans are designed
                for buyers with limited or imperfect credit histories. FHA
                guidelines are more forgiving than conventional loan
                requirements, increasing the likelihood of approval for many.
              </li>
              <li>
                <b>Higher Debt-to-Income Allowance:</b> FHA loans typically
                allow for a higher debt-to-income ratio, enabling more buyers to
                qualify even if they have existing financial obligations.
              </li>
            </ul>
            <span className="purchaseBottomLeftSubHeader">Cons:</span>
            <ul className="purchaseBottomLeftUL paperworkBottomLeftUL">
              <li>
                <b>Mortgage Insurance Premiums:</b> Both an upfront premium and
                ongoing monthly payments are required, which can increase the
                overall cost of the loan.
              </li>
              <li>
                <b>Property Standards:</b> Homes financed by FHA loans must meet
                strict safety, security, and livability standards, which may
                limit available properties.
              </li>
              <li>
                <b>Loan Limits:</b> There are limits on the maximum loan amount
                based on property location, potentially restricting buyers in
                high-cost areas.
              </li>
            </ul>
            <span className="purchaseBottomLeftContent">
              Overall, FHA loans present a viable path to homeownership for
              many, but it’s essential to weigh these benefits against the
              associated costs and requirements.
            </span>
            <i className="purchaseBottomLeftContent">
              Disclaimer: This blog is for informational purposes only and does
              not constitute legal, financial, or tax advice. Please consult
              with a professional for personalized guidance.
            </i>

            <div className="purchaseBottomLeftButton">
              <a
                href="https://themortgageist.my1003app.com/2692605/register/"
                target="_blank"
                rel="noreferrer"
                className="purchaseBottomLeftButtonLink"
              >
                Apply Now
              </a>
            </div>
          </div>
          <FreeConsultation />
        </div>
      </div>
    </div>
  );
}

export default FHA;
